import React, { useEffect, useState } from "react";
import { useCountdownV2 } from "services";
import { DateTime } from "luxon";
import { Button } from "../../../../../shadcn/components/ui/button";
import { useRouter } from "next/router";

interface AuctionStartingSoonCardProps {
  eventData: any;
  status?: string;
}

export default function AuctionStartingSoonCard({
  eventData,
  status,
}: AuctionStartingSoonCardProps) {
  const router = useRouter();
  const [endTime, setEndTime] = useState<any>(0);
  const [timeOffset, setTimeOffset] = useState(0);
  const [serverTime, setServerTime] = useState(0);
  const [isLessThanOneDay, setIsLessThanOneDay] = useState(false);

  const updateLessThanOneDay = (startDateTimeISO?: string, offset = 0) => {
    if (!startDateTimeISO) {
      setIsLessThanOneDay(false);
      return;
    }
    const startMillis = DateTime.fromISO(startDateTimeISO)
      .setZone("Asia/Kolkata")
      .toMillis();
    const nowMillis = Date.now() + offset;
    const diffHours = (startMillis - nowMillis) / (1000 * 60 * 60);
    setIsLessThanOneDay(diffHours > 0 && diffHours < 24);
  };

  useEffect(() => {
    const calculateEndTimeAndTimeOffset = () => {
      setServerTime(eventData?.server_time);
      setEndTime(eventData?.start_date_time);
      updateLessThanOneDay(eventData?.start_date_time, timeOffset);
    };
    calculateEndTimeAndTimeOffset();
  }, [
    eventData?.start_date_time,
    eventData?.server_time,
    eventData,
    timeOffset,
  ]);

  useEffect(() => {
    if (serverTime) {
      const serverDateTime =
        DateTime.fromMillis(serverTime).setZone("Asia/Kolkata");
      const localDateTime = DateTime.now().setZone("Asia/Kolkata");
      const offset = serverDateTime.toMillis() - localDateTime.toMillis();
      setTimeOffset(offset);
    }
  }, [serverTime]);

  useEffect(() => {
    updateLessThanOneDay(endTime, timeOffset);
    const timer = setInterval(() => {
      updateLessThanOneDay(endTime, timeOffset);
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime, timeOffset]);

  const [hours, minutes, seconds, isTimeEnded] = useCountdownV2(
    endTime,
    timeOffset,
  );
  const padTime = (value: number) =>
    value > 0 ? String(value).padStart(2, "0") : "00";

  return (
    <>
      {status === "accepted" && (
        <div className="bg-white border rounded-sm px-3 py-2 text-sm text-brand-bgBlack mb-2 font-openSans font-semibold">
          <div className="flex items-center justify-between">
            <div className="font-semibold text-brand-textDarkGrey">
              The Auction event is scheduled to start at{" "}
              <span className="font-bold text-brand-bgBlack">
                {DateTime.fromISO(eventData?.start_date_time)
                  .setZone("Asia/Kolkata")
                  .toFormat("dd LLL yyyy, hh:mm a")}
              </span>
              {". "}
              {isLessThanOneDay && (
                <>
                  Auction floor will open for bidding in{" "}
                  <span className="font-bold text-brand-bgBlack pt-1">
                    {padTime(hours)}h:{padTime(minutes)}m:{padTime(seconds)}s
                  </span>
                </>
              )}
            </div>

            <Button
              variant="ghost"
              className="h-5 text-xs font-semibold text-brand-orange hover:text-brand-orange hover:bg-transparent"
              onClick={() => router.reload()}
            >
              Refresh
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
